<template>
    <!-- <app-layout> -->


        <div class="mx-auto flex flex-grow flex-col" 
            :class="{'-mt-6' : is_visitor}"
            style="background-image: url(/img/birdie-icon-pattern.svg);">
            
            <div class="w-full h-full bg-birdie-dark bg-opacity-70">
                
                <div class="flex flex-grow h-full flex-col justify-center items-center relative overflow-y-scroll bg-birdie-dark bg-opacity-70">
                    <div class="flex w-full max-w-screen-lg">
                        <div class="mb-0 mt-4 md:mt-0 mx-auto relative flex overflow-hidden justify-center items-center ">

                            <div class="blurcs_md p-5 flex">
                                <img src="/img/screenrecording-home.png" class="opacity-50" />
                            </div>
                            
                            <div :class="[plan_screenrecording ? 'justify-center' : 'justify-end', 'absolute flex flex-grow w-full h-full flex-col items-center']">
                                
                                
                                <div class="bg-white p-20 mx-10 rounded-xl shadow-xl text-center">
                                    
                                    <p v-if="!is_visitor" class="font-bold">You did not enable Screen Recording.</p>

                                    <p v-if="is_visitor" class="font-bold">Screen Recording has been disabled<br />in this Birdie account.</p>
                                    
                                    <p v-if="!is_visitor" class="font-bold mt-5">Close this tab and enable Screen Recording into your Birdie account.</p>
                                    
                                    <div v-if="!is_visitor">
                                        <div class="text-sm text-center">(An administrator account is needed)</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    <!-- </app-layout> -->
</template>

<script>
    import BlankLayout from '@/Layouts/BlankLayout'

    export default {
        props: [ 'screenrecording_enabled', 'plan_screenrecording', 'is_visitor'],
        components: {
            BlankLayout,
        },
        layout: BlankLayout, // keep layout in place avoid refreshing it
        data() {
            return {

            }
        },
        created() {
            // this.EventBus.on("start.call", function(toto) {
            //     this.test(toto)
            // }.bind(this));
        },
        beforeUnmount() {
            // this.EventBus.off("start.call", this.test);
        },
        mounted() {
            // this.EventBus.emit("start.call", "hello")
        },
        methods: {
            // test(toto) {
            //     console.log("test ok", toto)
            // }
        }
    }
</script>
